// extracted by mini-css-extract-plugin
export var banner = "_1s-0";
export var icon = "_1s-1";
export var message = "_1s-2";